import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

// Contexts
import { AuthContext } from "../../context/AuthProvider";
import { ThemeContext } from "../../context/ThemeProvider";

// Components
import {
  FlashcardsProgress,
  FlashcardDisplay,
  EmptyFlashcardsState
} from "../../components/flashcardsStudy";
import NavBar from "../../components/NavBar";
import CommonHeader from "../../components/common/CommonHeader";
import UpgradeBanner from "../../components/common/UpgradeBanner";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";

// Constants
import { STRINGS } from "../../constant";

const QuickSets = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { theme } = useContext(ThemeContext);
  const {
    profile,
    addFlashcardToBookmark,
    removeFlashcardFromBookmark,
    addFlashcardProgress,
    isSubscribe,
    flashCardsList,
  } = useContext(AuthContext);

  console.log("QuickSets -> state", state);
  // Extract state data
  const title = state?.title || STRINGS.flashcards;
  const lastIndex = state?.lastIndex || 0;
  const set_id = state?.set_id || "";
  const cards = state?.cards || [];
  console.log("QuickSets -> cards", cards);

  // State management
  const [activeIndex, setActiveIndex] = useState(lastIndex);
  const [flippedCards, setFlippedCards] = useState({});

  // Track progress when card changes
  useEffect(() => {
    if (set_id && cards.length > activeIndex) {
      const card = cards[activeIndex];
      addFlashcardProgress(set_id, card.id);
    }
  }, [activeIndex]);

  // Reset flip state when card changes
  useEffect(() => {
    setFlippedCards({});
  }, [activeIndex]);

  // Navigation handlers
  function handlePrevious() {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  }

  function handleNext() {
    if (activeIndex < cards.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  }

  // Bookmark handling
  function isBookmarked() {
    if (cards.length > activeIndex) {
      const card = cards[activeIndex];
      return profile?.flashcard_bookmarks?.includes(card.id) || false;
    }
    return false;
  }

  function handleBookmark() {
    if (cards.length > activeIndex) {
      const card = cards[activeIndex];
      if (isBookmarked()) {
        removeFlashcardFromBookmark(card.id);
      } else {
        addFlashcardToBookmark(card.id);
      }
    }
  }

  // Flip card handler
  function handleFlipCard(cardId) {
    setFlippedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  }

  // Navigate to specific card
  function handleCardSelect(index) {
    setActiveIndex(index);
  }

  if (cards.length === 0) {
    return (
      <EmptyFlashcardsState 
        title={title}
        onBack={() => navigate(-1)}
        theme={theme}
      />
    );
  }

  const currentCard = cards[activeIndex];
  console.log("QuickSets -> currentCard", currentCard);
  const isFlipped = flippedCards[currentCard?.id] || false;

  return (
    <div className="min-h-screen transition-colors duration-300" 
         style={{ background: theme?.background?.main }}>
      <div className="mx-4 sm:mx-4 md:mx-8 lg:mx-8 mb-4 sm:mb-4 md:mb-8 lg:mb-8">
        {/* Header */}
        
        
        <CommonHeader
          title="Flashcards"
          icon={faLayerGroup}
          iconType="fontawesome"
          onBack={() => navigate(-1)}
          theme={theme}
          showBackButton={true}
        />

        {/* Progress */}
        <FlashcardsProgress
          currentIndex={activeIndex}
          totalCards={cards.length}
          cards={cards}
          isBookmarked={isBookmarked()}
          onBookmark={handleBookmark}
          onCardSelect={handleCardSelect}
          theme={theme}
        />

        {/* Upgrade Banner for Free Users on Last Card */}
        {!isSubscribe && activeIndex === cards.length - 1 && cards.length > 0 && (
          <UpgradeBanner
            type="flashcard"
            length={flashCardsList?.length}
            theme={theme}
            onUpgrade={() => navigate('/chooseplan')}
          />
        )}

        {/* Flashcard Display */}
        <AnimatePresence mode="wait">
          {currentCard && (
            <motion.div
              key={currentCard.id}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3 }}
            >
              <FlashcardDisplay
                card={currentCard}
                isFlipped={isFlipped}
                onFlip={() => handleFlipCard(currentCard.id)}
                theme={theme}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      
      
      <NavBar
          type="test"
          onNext={handleNext}
          onPrevious={handlePrevious}
          currentIndex={activeIndex}
          dataSet={cards?.length ?? 0}
          navTitle="Flashcard"
          showEnd={false}
          onEndTest={() => {}}
        />
    </div>
  );
};

export default QuickSets;